import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const avalara = defineConnector({
  identifier: "avalara",
  name: "Avalara",
  tagLine: "Sales tax automation",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://rest\\.avatax\\.com/api/v2/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }).withHeaders([
      {
        name: "x-avalara-client",
        value: app.config.avalaraClient,
      },
    ]),
  steps: [
    {
      title: "Find your Avalara API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Avalara AvaTax getting started docs](https://developer.avalara.com/avatax/getting-started/) and generate API credentials in your AvaTax admin account. Copy the account username and license key that Avalara provides for API access.",
        },
      ],
    },
    {
      title: "Connect your Avalara account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Avalara instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Avalara Client",
          placeholder: "your-avalaraClient",
          required: true,
          target: { kind: "configuration", field: "avalaraClient" },
          helperText: "The Avalara client for your Avalara account",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "Avalara User Name / Account ID",
        },
        {
          kind: "input",
          label: "Avalara Password",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "Your Password / License Key",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://rest.avatax.com/api/v2/utilities/subscriptions",
  },
});
